import * as React from 'react';
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19.92} height={20.003} {...props}>
    <g fill="#50cc00" data-name="Group 8661">
      <path
        d="M15.615 4.307h-5.519c-.514 0-.725-.211-.725-.725V.692a.6.6 0 0 1 .514-.685h9.346a.6.6 0 0 1 .685.514v8.278a.608.608 0 0 1-.514.675h-3.1a.608.608 0 0 1-.675-.514V4.307Z"
        data-name="Path 5779"
      />
      <path
        d="M4.295 6.345h2.5a.585.585 0 0 1 .624.534v6.244a.586.586 0 0 1-.544.624H3.752a.587.587 0 0 1-.634-.544v-2.591H.67a.6.6 0 0 1-.665-.514V1.83a.593.593 0 0 1 .52-.665h3.1a.608.608 0 0 1 .675.514v4.653Z"
        data-name="Path 5780"
      />
      <path
        d="M10.146 15.702V9.907c0-.534.2-.735.745-.735h2.872a.61.61 0 0 1 .685.514v9.616a.618.618 0 0 1-.514.685H6.148a.6.6 0 0 1-.675-.514v-3.1a.6.6 0 0 1 .514-.665h4.159Z"
        data-name="Path 5781"
      />
      <path
        d="M19.905 16.292v3.021a.6.6 0 0 1-.514.685H16.28a.608.608 0 0 1-.675-.514v-6.223a.593.593 0 0 1 .5-.675h3.13a.6.6 0 0 1 .665.524v3.183Z"
        data-name="Path 5782"
      />
      <path
        d="M.005 17.833v-1.485a.589.589 0 0 1 .534-.645h3.132a.586.586 0 0 1 .634.534v3.122a.586.586 0 0 1-.534.634H.65a.6.6 0 0 1-.645-.534v-1.626Z"
        data-name="Path 5783"
      />
    </g>
    <g fill="#28b700" data-name="Group 8662">
      <path
        d="M15.615 4.307h-5.519c-.514 0-.725-.211-.725-.725V.692a.6.6 0 0 1 .514-.685h9.346a.6.6 0 0 1 .685.514v8.278a.608.608 0 0 1-.514.675h-3.1a.608.608 0 0 1-.675-.514V4.307Z"
        data-name="Path 5779"
      />
      <path
        d="M.525 1.175h3.1a.608.608 0 0 1 .675.514v4.656h2.5a.578.578 0 0 1 .625.53v2L.005 2.897V1.84a.593.593 0 0 1 .52-.665Z"
        data-name="Path 11186"
      />
      <path
        d="M10.146 11.085V9.917c0-.534.2-.735.745-.735h2.87a.618.618 0 0 1 .685.514v4.864l-4.29-3.465Z"
        data-name="Path 11187"
      />
      <path
        d="M16.119 12.586h3.122a.6.6 0 0 1 .665.524v5.851l-4.29-3.465v-2.235a.593.593 0 0 1 .5-.675Z"
        data-name="Path 11188"
      />
    </g>
  </svg>
);
export default SvgComponent;
